import { getApiQueryKey, useGetApiData } from "../../../../shared/datalayer";
import MyExpApi from "../../enum/MyExpApi";
import ApiAccessPrivilage from "../../../../shared/types/ApiAccessPrivilage";
import { QueryClient } from "react-query";

function getMyPrivilegesQueryKey(registrationParticipantId?: string) {
  return getApiQueryKey(MyExpApi.GET_MY_PRIVILEGES_LIST, {
    pathParams: { registrationParticipant: registrationParticipantId }
  });
}

export function useGetMyPrivilegesList(registrationParticipantId?: string, enabled?: boolean) {
  return useGetApiData<Array<ApiAccessPrivilage>>(
    MyExpApi.GET_MY_PRIVILEGES_LIST,
    {
      pathParams: { registrationParticipant: registrationParticipantId }
    },
    { enabled: Boolean(registrationParticipantId) && Boolean(enabled) }
  );
}

export function invalidateMyPrivilegesApiData(queryClient: QueryClient, registrationParticipantId?: string) {
  queryClient.invalidateQueries(getMyPrivilegesQueryKey(registrationParticipantId));
}
